import axios, { AxiosResponse } from 'axios';
import store from './../store';

export class FeatureFlagsService {
  static allFeatureFlags: any[] = [];

  static async init() {
    try {
      const response: AxiosResponse<any> = await axios.get('/api/v3/api/v2/ff');
      FeatureFlagsService.allFeatureFlags = response.data;
      store.commit('setFeatureFlagInitializedStatus', true);
    } catch (newBackendError) {
      console.warn('V3 feature flag endpoint failed. Falling back to v2...', newBackendError);
      try {
        const fallbackResponse: AxiosResponse<any> = await axios.get('/api/v2/ff');
        FeatureFlagsService.allFeatureFlags = fallbackResponse.data.data;
        store.commit('setFeatureFlagInitializedStatus', true);
        console.warn('Successfully loaded feature flags from legacy v2 fallback.');
        
      } catch (oldBackendError) {
        console.error('Both feature flag backend endpoints failed.', oldBackendError);
        store.commit('setSnackbar', { serverMessage: 'Error: Unable to load feature flags.', show: true, color: 'error' })
      }
    }
  }

  static checkStatus(featureFlagName: string) {
    const featureFlag = FeatureFlagsService.allFeatureFlags.find(featureFlag => featureFlag.name === featureFlagName);
    if (featureFlag) {
      return featureFlag.status;
    }
    return false;
  }

  static filterGroupsUsingFeatureFlags(groups: any[]) {
    const filteredGroups = groups.filter(group => FeatureFlagsService.checkStatus(group.featureFlag))
    const filteredGroupsWithFilteredItems = filteredGroups.map(currentGroup => {
      const groupItems = currentGroup.groupItems.map((currentGroupRow: any[]) => {
        return currentGroupRow.filter(currentItem => FeatureFlagsService.checkStatus(currentItem.featureFlag));
      })
      return { ...currentGroup, groupItems };
    });
    return filteredGroupsWithFilteredItems
  }
}